import { BankAccount } from "@/api/bank-accounts";
import { useNavigate, Link } from "@tanstack/react-router";
import { ChevronRight, Landmark } from "lucide-react";
import { Button } from "../../../ui/button/button";

type AccountsCardProps = {
	accounts: BankAccount[];
};

const AccountsCard = ({ accounts }: AccountsCardProps) => {
	const navigate = useNavigate();
	return (
		<div className="py-6 px-10 bg-primary-50 rounded-3xl">
			<h2 className="text-lg font-bold text-textDark">Fast Withdrawal</h2>
			{accounts.map((account) => (
				<Link
					data-testid="account-link"
					key={account.id}
					className="flex items-center justify-between gap-2 px-7 py-3 mt-4 bg-white cursor-pointer rounded-3xl"
					params={{ accountId: account.id.toString() }}
					to={"/main/withdraw/$accountId/amount"}
				>
					<div className="flex items-center gap-4">
						{/* <img
						src={account.image}
						alt={`${account.name} logo`}
						className="w-8 h-8"
					/> */}
						<Landmark className="" />
						<div className="flex flex-col items-start justify-start">
							<h2 className="font-bold text-sm text-md text-textDark">
								{account.bank_name}
							</h2>
							<p className="mt-1 text-sm font-medium text-center text-textLight">
								{account.bank_account}
							</p>
						</div>
					</div>
					<ChevronRight className="w-6 h-6 text-textDark" />
				</Link>
			))}
			{/* <div className="flex items-center justify-between gap-2 px-4 py-3 mt-4 bg-white rounded-3xl"> */}
			{/* <img src="/account1.png" alt="bank" className="w-8 h-8" />
                <div className="flex flex-col items-center">
                    <h2 className="font-bold text-md text-textDark">
                        Wells Fargo - Nickname
                    </h2>
                    <p className="mt-1 text-sm font-medium text-center text-textDark">
                        Checking 8490
                    </p>
                </div> */}
			{/* <ChevronRight className="w-6 h-6 text-textDark" />
            </div> */}
			<Button
				className="w-full mt-6 text-base font-bold text-white bg-primary-600"
				onClick={() => {
					navigate({ to: "/main/setting/linked-accounts/new" });
				}}
			>
				+ Add account
			</Button>
		</div>
	);
};

export default AccountsCard;
